(function () {
    "use strict";
  
    async function clearCartEvent() {
      const lastClearTime = localStorage.getItem("lastClearTime");
  
      const currentTime = new Date();
      const currentHour = currentTime.getHours();
      const currentMinute = currentTime.getMinutes();
  
      const nextClearTime = new Date();
      nextClearTime.setHours(4, 0, 0, 0); // Set to 4:00 AM
      nextClearTime.setDate(nextClearTime.getDate() + 1); // Set to the next day
  
      if (!lastClearTime || currentTime >= new Date(lastClearTime)) {
        // Call the function to remove everything in the Shopify cart
        fetch("/cart/clear.js", { method: "POST" })
          .then(() => {
            console.log("Fox Flushing");
            localStorage.setItem("lastClearTime", nextClearTime);
          })
          .finally(() => {
            // Reload the page only if on the cart page
            if (window.location.href.includes("/cart")) {
              window.location.reload();
            }
          });
      }
    }
  
    function onDOMContentLoaded() {
      clearCartEvent();
    }
  
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", onDOMContentLoaded, {
        once: true,
      });
    } else {
      onDOMContentLoaded();
    }
})();
